export default class UpdateVariant {
	id: string;
	cost: number;

	constructor(id?: string, cost?: number) {
		this.id = id;
		this.cost = cost;
	}
}
